import { Component, OnInit , AfterViewInit} from '@angular/core';
import {FormGroup,Validators,FormBuilder} from '@angular/forms';
import {DataService} from '../data.service';
import {PasswordValidation} from '../password-validation';
import { ActivatedRoute, Router} from '@angular/router';
import {
  AuthService,
  FacebookLoginProvider,
  GoogleLoginProvider,
  LinkedinLoginProvider
} from 'ng4-social-login';

import { SocialUser } from 'ng4-social-login';
import {HomeComponent} from '../home/home.component';
import {Guest} from '../module-page/module-page.component';
import { MyDatePipe } from './../my-date.pipe';

declare var window: any;
declare var FB: any;
declare var $: any;
declare var fbq: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [ MyDatePipe ]
})
export class LoginComponent implements OnInit,AfterViewInit {
  isLogin:boolean=true;
  isSignUp:boolean=false;
  isPassword:boolean=true;
  isConfPassword:boolean=true;
  userForm:FormGroup;
  userName:string="";
  userTypeId:number=-1;
  public user: SocialUser;
  public loggedIn: boolean;
  mobilePopup:boolean=false;
  socialForm:FormGroup;
  checkNoOfTimesLogin:number=0;
  termsModal:boolean=false;
  noOfTimesClicked:number=0;
  planId:number=-1;
  userId:number=-1;
  isNext:boolean=false;
  guest:Guest=null;

  constructor(
    private service:DataService,
    private fb:FormBuilder,
    private router:Router,
    private activeRouter: ActivatedRoute,
    private authService: AuthService,
    private home:HomeComponent,
    public datePipe: MyDatePipe
  ) {
    if(this.isLogin==true){
      this.userForm=this.fb.group({
        'name':[null,Validators.required],
        'phno':[null,Validators.compose([Validators.required,Validators.pattern("^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$")])],
        "email":[null,Validators.compose([Validators.required,Validators.email])],
        "password":[null,Validators.required],
        "confirm-password":[null,Validators.required],
        "remember_me":[false],
        "terms":[false,Validators.required]
      },
        {
          validator:PasswordValidation.MatchPassword
        })
    } else {
      this.userForm=this.fb.group({

        "email":[null,Validators.compose([Validators.required,Validators.email])],
        "password":[null,Validators.required],

      })
    }

    this.socialForm=this.fb.group({
      'mobile_no':[null,Validators.compose([Validators.required,Validators.pattern("^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$")])],
    })

  }

  ngOnInit() {
   // debugger;
    this.user=null;
    this.checkNoOfTimesLogin=0;
    sessionStorage.setItem("IsStratGistLogin", "false");
    if(sessionStorage.getItem("IsStratGistLogin")!=null){
    this.isLogin= sessionStorage.getItem("IsStratGistLogin")=="true" ? true : false;
    this.isSignUp=this.isLogin==true ? false : true
    }

    this.authService.authState.subscribe((user) => {
    
      this.user = user;
      this.checkNoOfTimesLogin++;
      if(this.user!=null && this.checkNoOfTimesLogin <=2){
        this.signUpSocialUser(this.user)
      }
      this.loggedIn = (user != null);
    });

    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    this.service.watchStorage().subscribe(()=>{
      if(sessionStorage.getItem("IsStratGistLogin")!=null){
      this.isLogin= sessionStorage.getItem("IsStratGistLogin")=="true" ? true : false;
      this.isSignUp=this.isLogin==true ? false : true
      if(this.isLogin){
        this.stratGistLogin(1);
      } else {
          this.stratGistLogin(0);
      }
    }
    })
  }  

  ngAfterViewInit(){
      $(window).scrollTop(0);

    // $('.cd-primary-nav-trigger').click(function(){
    //   if($('.cd-primary-nav').hasClass('is-visible')){
    //
    //     $('app-login').css('filter','blur(5px)');
    //   } else {
    //     $('app-login').css('filter','blur(0px)');
    //   }
    // })
      $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');
  }

  stratGistLogin(pvarChoice){
    if(pvarChoice==0){
      // sessionStorage.setItem("IsStratGistLogin","false");
      this.isSignUp=true;
      this.isLogin=false;
      this.userForm=this.fb.group({

        'name':[null,Validators.required],
        'phno':[null,Validators.compose([Validators.required,Validators.pattern("^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$")])],
        "email":[null,Validators.compose([Validators.required,Validators.email])],
        "password":[null,Validators.required],
        "confirm-password":[null,Validators.required],
        "terms":[false,Validators.required]
      },
        {
          validator:PasswordValidation.MatchPassword
        })

    } else {
      // sessionStorage.setItem("IsStratGistLogin","true");
      this.isSignUp=false;
      this.isLogin=true;

        this.userForm=this.fb.group({

          "email":[null,Validators.compose([Validators.required,Validators.email])],
          "password":[null,Validators.required],
          "remember_me":[false],

        })
    }
  }

  togglePassword(){
    this.isPassword=!this.isPassword;
  }

  toggleConfirmPassword(){
    this.isConfPassword=!this.isConfPassword;
  }

  signUpUser(form,social?:boolean){
    
    this.guest=sessionStorage.getItem('Guest')!=null ? JSON.parse(sessionStorage.getItem('Guest')) : null
    let inputJson={};

    var codeVar = localStorage.getItem('code');
    var dateVar = localStorage.getItem('linkOpeningDate');
    if(codeVar == undefined || codeVar == null || codeVar == '') {
      codeVar = "";
    } 
    if(dateVar == undefined || dateVar == null || dateVar == '') {
      dateVar = "";
    }

    if(social==true) {
      if(!this.socialForm.controls['mobile_no'].valid){
        this.service.alert("Invalid mobile no","error");
        return false;
      }

      this.mobilePopup=false;
      var name=this.user.name.split(' ');
      var first="";
      var last="";
      if(name.length==1){
        first=name[0];
      }
      if(name.length>1){
          first=name[0];
            for(var i=1;i<name.length;i++){
              last=last+name[i]+" ";
            }
            last=last.substring(0,last.length-1);
      }

       inputJson={

        "AccountType":"1",
        "Email":this.user.email,
        "FirstName":first,
        "LastName":last,
        "MobileNo":this.socialForm.value['mobile_no'],
        "Password":"",
        "UniqueId":this.user.id,
        "TestUserId":this.guest!=null ? this.guest.guestUserId : -1,
        "Code": codeVar,
	      "Date": dateVar,
      }
      if(this.user.provider=="FACEBOOK"){
        inputJson['AccountType']="2"
      }
      if(this.user.provider=="GOOGLE"){
        inputJson['AccountType']="3"
      }

      if(this.user.provider=="LINKEDIN"){
        inputJson['AccountType']="4"
      }

    } else {
      let a=new RegExp("^[0-9\.\-\/]+$");
      if(form.controls['name'].valid==false){
        this.service.alert('Please enter the full name',"error");
        return false;
      }

      if(a.test(form.controls['name'].value)==true){
        this.service.alert('The format of the name is invalid',"error");
        return false;
      }
      if(form.controls['phno'].valid==false){
        if(form.controls['phno'].hasError('required')){
          this.service.alert('Please enter your phone number',"error");
          return false;
        }
        else{
          this.service.alert('The format of your phone number is invalid',"error");
          return false;
        }
      }

      if(form.controls['email'].valid==false){
        if(form.controls['email'].hasError('required')){
          this.service.alert('Please enter your email',"error");
          return false;
        }
        else {
          this.service.alert('Invalid email format',"error");
          return false;
        }

      }

      if(form.controls['password'].valid==false){
        this.service.alert('Please enter the password',"error");
        return false;
      }

      if(form.controls['confirm-password'].valid==false){
        if(form.controls['confirm-password'].hasError('required')){
            this.service.alert("Please confirm your password","error");

          return false;
        } else {
        this.service.alert("Oops! Your passwords don’t match","error");
          return false;
        }

      }
      if(form.controls['terms'].value==false){
          this.service.alert("Please agree to terms and conditions","error");
          return false;
      }
        var name:string[]=form.value['name'].split(' ');
        var first="";
        var last="";
        if(name.length==1){
          first=name[0];
        }
        if(name.length>1){
            first=name[0];
              for(var i=1;i<name.length;i++){
                last=last+name[i]+" ";
              }
              last=last.substring(0,last.length-1);
        }


       inputJson={
      	"AccountType":"1",
      	"Email":form.value['email'],
      	"FirstName":first,
      	"LastName":last,
      	"MobileNo":form.value['phno'],
      	"Password":form.value['password'],
      	"UniqueId":"",
        "TestUserId":this.guest!=null ? this.guest.guestUserId : -1,
        "Code": codeVar,
	      "Date": dateVar,
      }
    // console.log(JSON.stringify(inputJson),undefined,2);
    }
    localStorage.setItem("UserEmail",form.value['email']);
    sessionStorage.setItem("UserEmail",form.value['email']);
    sessionStorage.setItem("UserPass",form.value['password']);

    this.service.SignUpUserV3ForLandingPage(inputJson)
      .subscribe(
        (result: any[]) => {
          if (result['Status'] == "Success") {
            this.userTypeId=result['UserTypeId'];


            this.service.alertMessage('Sign up successful', 'success');
            sessionStorage.removeItem('Guest');
            // fbq('track', 'CompleteRegistration');
            localStorage.setItem("UserName", result['Name']);
            localStorage.setItem("UserId", result['Id']);
            localStorage.setItem("UserTypeId",JSON.stringify(this.userTypeId));
            this.router.navigate(['/landing-modules']);
            sessionStorage.removeItem('moduleId');
          }
          // this.service.alertMessage(result['Message'],'error');
          else {
            this.service.alertMessage(result['Message'], 'error');
            sessionStorage.removeItem('SocialUser');
          }
        },
      (error) => {
        console.log(error);
      }
    )

  }

  loginUser(form,fromOutside?:boolean){
  
    if(sessionStorage.getItem('Guest')!=null){
      this.guest=JSON.parse(sessionStorage.getItem('Guest'));
    } else {
      this.guest=null;
    }

    let inputJson={};
    if(fromOutside==true){
      // console.log("login user from outside");
      inputJson={
       "Email":localStorage.getItem("UserEmail"),
       "Pwd":sessionStorage.getItem("UserPass"),
       "UniqueId":this.user==null ? "" : this.user.id,
       "TestUserId":this.guest!=null ? this.guest.guestUserId : -1,
     }
     this.service.LoginUser(inputJson)
       .subscribe(
         (result:any[])=>{
           if(result['Status']=="Success"){

             this.service.alertMessage('Welcome to the world of StratGist','success',500);

             this.userName=result['Name'];
             this.userTypeId=result['UserTypeId'];
            //  alert(result['Email'])

             localStorage.setItem("planId",result['PlanId']);
             localStorage.setItem("UserEmail",form.value['email'] == null ? result['Email'] : form.value['email']);
             sessionStorage.setItem("UserEmail",form.value['email'] == null ? result['Email'] : form.value['email']);
             sessionStorage.setItem("UserPass",form.value['password']);
             sessionStorage.setItem('ModuleCompleted',result['ModuleCompleted']);
             localStorage.setItem("UserName",this.userName);
             localStorage.setItem("UserTypeId",JSON.stringify(this.userTypeId));
               localStorage.setItem("UserId",result['Id']);
                 sessionStorage.setItem('UserRole',result['UserRole']==null ? '' : result['UserRole']);
                   sessionStorage.setItem('Department',result['Department']==null ? '' : result['Department']);
                   sessionStorage.setItem('Company',result['CompanyName']==null ? '' : result['CompanyName']);
                 this.service.storageSub.next('change');
               if(sessionStorage.getItem('reminder-subscription')==null){
                   sessionStorage.setItem('reminder-subscription','true');
                   this.service.storageSub.next('change');
               } else {

               }

               sessionStorage.setItem("companyId",result['CompanyId']);
               var myObj={};
               myObj['LastActiveDay']=result['LastActiveDay'];
               myObj['ModuleCompleted']=result['ModuleCompleted'];
               myObj['TotalModule']=result['TotalModule'];
               myObj['UserAvgScore']=Math.round(result['UserAvgScore']);
               localStorage.setItem("loginUserData",JSON.stringify(myObj));

               if(sessionStorage.getItem('from-payment')!=null){
                  // this.router.navigate(['/pricing']);
               } else {
                 if(result['IsUserInterset']==true){
                  this.router.navigate(['/landing-modules']);
                 } else {
                  this.router.navigate(['/landing-modules']);

                 }
               }

               if(sessionStorage.getItem('isRecommended')=="true"){
                 this.router.navigate(['all-modules','Recommended'])
               }
               sessionStorage.setItem('CurrentTime','0');
               sessionStorage.removeItem('Guest');
               sessionStorage.removeItem('moduleId');
                this.service.storageSub.next('change');
           }
           else {
             this.service.alertMessage(result['Message'],'error');
             this.noOfTimesClicked=0;
           }
         },
         (error)=>{
           console.log(error);
         }
       )
   } else {
      if(sessionStorage.getItem('Guest')!=null){
           this.guest=JSON.parse(sessionStorage.getItem('Guest'));
      } else {
        this.guest=null;
      }

     if(!form.controls['email'].valid){
       if(form.controls['email'].hasError('required')){
          this.service.alert('Please enter your email','error');
       }
        else {
          this.service.alert('Invalid email format','error');
        }
       return false;
     }
     if(!form.controls['password'].valid){
       this.service.alert('Please enter the password','error');
       return false;
     }
     if(this.user==null){
       inputJson={
      	"Email":form.value['email'],
      	"Pwd":form.value['password'],
        "UniqueId":"",
        "TestUserId":this.guest!=null ? this.guest.guestUserId : -1,

      }
    }else{
      inputJson={
       "Email":form.value['email'],
       "Pwd":form.value['password'],
       "UniqueId":this.user.id,
       "TestUserId":this.guest!=null ? this.guest.guestUserId : -1,
     }
    }
    if(form.value['remember_me']){
      localStorage.setItem('keepEmail',form.value['email']);
      localStorage.setItem('keepPassword',form.value['password']);
      localStorage.setItem('checkbox','true');
    }
   }
   if(form.controls['email'].valid==true && form.controls['password'].valid==true){
      this.noOfTimesClicked+=1;
     if(this.noOfTimesClicked==1){

       this.service.LoginUser(inputJson)
         .subscribe(
           (result:any[])=>{
             if(result['Status']=="Success"){
              // alert('LoginUser')
               this.service.alertMessage('Welcome to the world of StratGist','success',500);

               this.userName=result['Name'];
               this.userTypeId=result['UserTypeId'];
               localStorage.setItem("planId",result['PlanId']);
               localStorage.setItem("UserEmail",form.value['email'] == null ? result['Email'] : form.value['email']);
               sessionStorage.setItem("UserEmail",form.value['email'] == null ? result['Email'] : form.value['email']);
               sessionStorage.setItem("UserPass",form.value['password']);
               sessionStorage.setItem('ModuleCompleted',result['ModuleCompleted']);
               localStorage.setItem("UserName",this.userName);
               localStorage.setItem("UserTypeId",JSON.stringify(this.userTypeId));
                 localStorage.setItem("UserId",result['Id']);
                   sessionStorage.setItem('UserRole',result['UserRole']==null ? '' : result['UserRole']);
                     sessionStorage.setItem('Department',result['Department']==null ? '' : result['Department']);
                     sessionStorage.setItem('Company',result['CompanyName']==null ? '' : result['CompanyName']);
                   this.service.storageSub.next('change');
                 if(sessionStorage.getItem('reminder-subscription')==null){
                     sessionStorage.setItem('reminder-subscription','true');
                     this.service.storageSub.next('change');
                 } else {

                 }

                 sessionStorage.setItem("companyId",result['CompanyId']);
                 var myObj={};
                 myObj['LastActiveDay']=result['LastActiveDay'];
                 myObj['ModuleCompleted']=result['ModuleCompleted'];
                 myObj['TotalModule']=result['TotalModule'];
                 myObj['UserAvgScore']=Math.round(result['UserAvgScore']);
                 localStorage.setItem("loginUserData",JSON.stringify(myObj));


                 if(sessionStorage.getItem('from-payment')!=null){
                    this.router.navigate(['/pricing']);
                 } else {
                   if(result['IsUserInterset']==true){
                    this.router.navigate(['/landing-modules']);
                   } else {
                     this.router.navigate(['/landing-modules']);

                   }
                 }
                 if(sessionStorage.getItem('isRecommended')=="true"){
                   this.router.navigate(['all-modules','Recommended'])
                 }
                  sessionStorage.removeItem('Guest');
                 sessionStorage.setItem('CurrentTime','0');
                  sessionStorage.removeItem('moduleId');
                  this.service.storageSub.next('change');
             }
             else {
               this.service.alertMessage(result['Message'],'error');
               this.noOfTimesClicked=0;
             }
           },
           (error)=>{
             console.log(error);
           }
         )
     }
   }

  }

  // signInWithGoogle(): void {

  //   if(this.loggedIn==true){
  //       this.signOut();
  //   }

  //   setTimeout(()=>{

  //     this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
      

  //   },1000)
  //   this.authService.authState.subscribe((user) => {
    
  //     this.user = user;
  //     this.checkNoOfTimesLogin++;
  //     if(this.user!=null && this.checkNoOfTimesLogin <=2){
  //       this.signUpSocialUser(this.user)
  //     }
  //     this.loggedIn = (user != null);
  //   });

  // }
  signInWithGoogle(): void {

    if(this.loggedIn==true){
        this.signOut();
    }

    setTimeout(()=>{

      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);



    },1000)

  }
  signInWithFB(): void {
    if(this.loggedIn==true){
        this.signOut();
    }
      setTimeout(()=>{
        this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);

      },1000)



  }

  signInWithLinkedIN(): void {

    if(this.loggedIn==true){
        this.signOut();
    }
    setTimeout(()=>{
      this.authService.signIn(LinkedinLoginProvider.PROVIDER_ID);


    },1000)


  }

  signOut(): void {

    if(this.user!=null||localStorage.getItem("UserId")!=null){
      this.checkNoOfTimesLogin=0;
      // console.log("sign out");
        this.authService.signOut();
    }


  }

  signUpSocialUser(user) {
    // debugger;
    //  alert('signUpSocialUser'+JSON.stringify(user))
    if(sessionStorage.getItem("SocialUser")==null){
        sessionStorage.setItem("SocialUser",JSON.stringify(user));
    }
    if(sessionStorage.getItem('Guest')!=null){
      this.guest=JSON.parse(sessionStorage.getItem('Guest'))
    } else {
      this.guest=null
    }
    this.service.LoginUser({"Email":user.email,"Pwd":" ","UniqueId":user.id,"TestUserId":this.guest!=null ? this.guest.guestUserId : -1}).
    subscribe(
      (result:any[])=>{
       
          if(result['Status']=="Success"){

            this.service.alertMessage('Welcome to the world of StratGist','success',500);
//alert('newuser'+result['UserTypeId'])
            this.userName=result['Name'];
            this.userTypeId=result['UserTypeId'];
            localStorage.setItem("UserName",this.userName);
            localStorage.setItem("UserEmail",result['Email']);
            localStorage.setItem("UserTypeId",JSON.stringify(this.userTypeId));
              localStorage.setItem("UserId",result['Id']);
              sessionStorage.setItem("companyId",result['CompanyId']);
              localStorage.setItem("planId",result['PlanId'])
              sessionStorage.setItem('ModuleCompleted',result['ModuleCompleted']);
              sessionStorage.setItem("reminder-subscription","true");
              sessionStorage.setItem('UserRole',result['UserRole']==null ? '' : result['UserRole']);
              sessionStorage.setItem('Company',result['CompanyName']==null ? '' : result['CompanyName']);
              sessionStorage.setItem('Department',result['Department']==null ? '' : result['Department']);
              this.service.storageSub.next('change');
              var myObj={};
              myObj['LastActiveDay']=result['LastActiveDay'];
              myObj['ModuleCompleted']=result['ModuleCompleted'];
              myObj['TotalModule']=result['TotalModule'];
              myObj['UserAvgScore']=result['UserAvgScore'];
              localStorage.setItem("loginUserData",JSON.stringify(myObj));


              if(sessionStorage.getItem('from-payment')!=null){
                 this.router.navigate(['/pricing']);
                //  alert("price")
              } else {
                if(result['IsUserInterset']==true){
                  // alert("landing1")
                 this.router.navigate(['/landing-modules']);
                } else {
                  // alert("landing2")
                  this.router.navigate(['/landing-modules']);

                }
              }
             sessionStorage.removeItem('Guest');
            sessionStorage.setItem('CurrentTime','0');
             sessionStorage.removeItem('moduleId');
             this.service.storageSub.next('change');
          }

          else {

           // this.noSocialSignUp();
            this.mobilePopup=true;
          }
      },
      (error)=>{
        console.log(error);
      }

    )

  }

  forgetPassword(){
    let email=this.userForm.controls['email'];
    if(email.value == '' || email.value == null){
      this.service.alert("Please enter your email address","error");
      return false;
    }
    if(this.userForm.controls['email'].invalid){
      this.service.alert("Please enter valid email address","error");
      return false;
    }
    const inputJson= {
      "EmailID":email.value
    }
    if(email.valid) {
      this.service.ForgetPassword(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
            this.service.alert('An email with the details is on the way',"success");
          } else {
            this.service.alert(result['Message'],"error")
          }
        },
        (error)=>{
          console.log(error);
        }
      )
    } else {
      return false;
    }

  }

  noSocialSignUp(){
    this.mobilePopup=false;
    this.user=null;
      sessionStorage.removeItem("SocialUser");
  }

  openTermsModal(){
    this.termsModal=true;
  }

  showActiveModule(pvarChoice){
    this.home.showActiveModule(pvarChoice);
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/login/login.component.ts